import { createFileRoute } from "@tanstack/react-router";
import { parseMgmtSearch } from "@/features/mgmt-performance/search";

/**
 * Hiệu suất quản lý. Thẻ, cụm, cơ sở, tháng nằm trên đường dẫn — bấm Quay lại
 * là về đúng bậc, và gửi link cho người khác được.
 */
export const Route = createFileRoute("/_app/mgmt-performance/")({
  validateSearch: parseMgmtSearch,
});
